import { Injectable } from '@angular/core';
import { AdminPortalWidgetContextData, ApiConfig } from '../../widget-context.type';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
// Admin Widget Context Service
export class AdminContextService {
  public adminPortalWidgetContext: AdminPortalWidgetContextData;
  public adminPortalWidgetContext$ = new Subject<AdminPortalWidgetContextData>();
  public appInitialized$ = new Subject<void>();

  constructor() {
    // Comment for SQ
  }

  public setAdminWidgetContext(adminPortalWidgetContext: AdminPortalWidgetContextData): void {
    this.adminPortalWidgetContext = adminPortalWidgetContext;
    this.adminPortalWidgetContext$.next(adminPortalWidgetContext);
  }

  public getAdminWidgetContext(): Observable<AdminPortalWidgetContextData> {
    return this.adminPortalWidgetContext$ as Observable<AdminPortalWidgetContextData>;
  }

  public get apiConfig(): ApiConfig {
    return this.adminPortalWidgetContext?.apiConfig;
  }

  public get lenderCode(): string {
    return this.adminPortalWidgetContext?.lenderConfig?.lenderCode;
  }

  public get tenantId(): string {
    return this.adminPortalWidgetContext?.tenantId;
  }

  public get lenderGuid(): string {
    return this.adminPortalWidgetContext?.lenderConfig?.lenderGuid;
  }
}
